import React from "react";

import { Presenter } from "./Presenter";

import { Props } from "../../types/FlowListItem";

export const FlowList: React.VFC<Props> = (props) => {
  return <Presenter {...props} />;
};
